export function analytics(tag: string, data = {}, showConsolLog = false) {
  if (showConsolLog) {
    console.log('analytics -> ', tag, data ?? null)
  }
  if (window.analytics) {
    window.analytics.track(tag, data)
  }
}